import axios from '../utils/request';
import { IObject, IResponse } from '../constants/interface';
import { AxiosRequestConfig } from 'axios';

/** GET */
function GET(url: string, params: IObject = {}, otherConfig?: AxiosRequestConfig,): Promise<IResponse> {
  return axios.get(url, { params, ...otherConfig });
}

export default GET;
